export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15002.5432a5e4.jpg";